import CustomButton from 'components/CustomInput/Button';
import TextHeader from 'components/CustomText/TextHeader';
import useAmendmentButton from 'hooks/useAmendmentButton';
import { isArray } from 'lodash';
import React from 'react';
import styled from 'styled-components/macro';
import { permissionChecking } from 'utility/general';

const SLayout = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const SButtonLayout = styled.div`
    margin-right: 20px;
`;

const AmendmentBar = ({
    currentTab,
    applicationDetail,
    siteInfoId,
    amendId,
    amendmentType,
    isAmendmentEdit,
    isAmendmentCreate,
    documentType,
    backToStudyInfo = () => null,
}) => {
    const hasPermission = permissionChecking({
        tabType: currentTab.type,
        siteInfoId,
        applicationDetail,
        isAmendmentCreate,
        isAmendmentEdit,
        amendmentType,
        amendId,
    });

    const amendmentButtons = useAmendmentButton({
        applicationDetail,
        amendId,
        amendmentType,
        isAmendmentEdit,
        isAmendmentCreate,
        siteInfoId,
        tabType: currentTab.type,
        currentTabKey: currentTab.key,
        documentType,
        backToStudyInfo,
        hasPermission,
    });

    const statusId = applicationDetail.status.statusId;

    return (
        <SLayout>
            <div style={{ display: 'flex' }}>
                {amendmentButtons
                    .filter((item) => {
                        if (item.status === undefined) {
                            return true;
                        }

                        // if status is array
                        if (typeof item.status === 'object') {
                            return item.status.includes(statusId);
                        }

                        return item.status === statusId;
                    })
                    .filter((item) => {
                        if (item.condition !== undefined) {
                            return item.condition({ currentTab: currentTab.key });
                        }

                        return true;
                    })
                    .filter((item) => {
                        if (item.showInTab) {
                            if (isArray(item.showInTab)) {
                                return item.showInTab.includes(currentTab.type);
                            }
                            return currentTab.type === item.showInTab;
                        }
                        return true;
                    })
                    .map((button, index) => {
                        const extraProps = {};

                        if (button.icon) {
                            extraProps.startIcon = button.icon;
                        }

                        return (
                            <SButtonLayout key={`${button.text}-${index}`}>
                                {button && button.customDialog}
                                <CustomButton
                                    {...extraProps}
                                    onClick={() => button.action()}
                                    disabled={button.isDisabled?.()}
                                    type={button.type}
                                >
                                    {button.text}
                                </CustomButton>
                            </SButtonLayout>
                        );
                    })}
            </div>
            <TextHeader>{!hasPermission && <div>View Only</div>}</TextHeader>
        </SLayout>
    );
};

export default AmendmentBar;
